import { TabConfigType } from '@common';
import { FinanceEndKey } from 'src/i18next';

type FinanceTab = TabConfigType<'overview' | 'deposits'> & {
  labelKey: FinanceEndKey<'TABS'>;
  path: string;
};

export const tabs: FinanceTab[] = [
  { labelKey: 'OVERVIEW', value: 'overview', path: '/finance/overview', requiredPermissions: [] },
  { labelKey: 'DEPOSITS', value: 'deposits', path: '/finance/deposits', requiredPermissions: [] },
];
